/**
 * Participation Chart Component
 * 
 * Displays participation trends over time using a line chart
 * - Shows event participation over time
 * - Displays attendance trends
 * 
 * Requirements: 5.5
 */

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export interface ParticipationData {
  date: string;
  events: number;
  hours: number;
}

interface ParticipationChartProps {
  data: ParticipationData[];
  title?: string;
}

export function ParticipationChart({ data, title = 'Participation Trends' }: ParticipationChartProps) {
  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold text-primary-900 mb-4">{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={data}
          margin={{ top: 5, right: 5, left: -20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="date" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '8px',
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: '14px' }}
          />
          <Line
            type="monotone"
            dataKey="events"
            stroke="#435d7d"
            strokeWidth={2}
            name="Events"
            dot={{ fill: '#435d7d', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="hours"
            stroke="#22c55e"
            strokeWidth={2}
            name="Hours"
            dot={{ fill: '#22c55e', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
